var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m5.306-2.834A1.75 1.75 0 0 1 8.956 6h1.822a1.972 1.972 0 0 1 .981 3.685l-1.009.578A.75.75 0 0 1 10 11a.75.75 0 0 1-.75-.75v-.422c0-.268.144-.515.378-.65l1.384-.793a.472.472 0 0 0-.234-.882H8.956c-.106 0-.2.066-.234.166l-.013.038a.75.75 0 0 1-1.412-.5l.012-.038zM9 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
  })));
};
export default SvgQuestionCircle;